<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted: function () {
    if (location.href.toLowerCase().indexOf('?returnurl=') > 0) {
      const queryIndex = location.href.toLowerCase().indexOf('?returnurl=');

      const hashIndex = location.href.lastIndexOf('#');
      let query = location.href.substring(queryIndex + 1);
      if (hashIndex > 0) {
        query = location.href.substring(queryIndex + 1, hashIndex);
      }

      const retUrl = decodeURIComponent(query.substring(10));
      this.$store.commit('setReturnUrl', retUrl);
    }

    this.$router.push({ path: '/' });
  }
};
</script>

<style></style>
